import CfdInstrumentIcon from './CfdInstrumentIcon';

export default CfdInstrumentIcon;
